import { useEffect, useState } from "react";
import { usePermissionsStore } from "@/stores/permissions";
import { useAuthStore } from "@/stores/auth";
import { isSponsoredRole } from "@/lib/permissions";

/** Keep a verified session usable while its permissions refresh in memory. */
export function useSubscriptionAccess() {
  const status = usePermissionsStore(
    (s) => s.subscriptionStatus,
  )?.toLowerCase();
  const currentTermEndsAt = usePermissionsStore((s) => s.currentTermEndsAt);
  const trialEndsAt = usePermissionsStore((s) => s.trialEndsAt);
  const loaded = usePermissionsStore((s) => s.loaded);
  const loading = usePermissionsStore((s) => s.loading);
  const subscriptionLoaded = usePermissionsStore((s) => s.subscriptionLoaded);
  const role = useAuthStore((s) => s.user?.role);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 60000);
    return () => window.clearInterval(id);
  }, []);

  const end = status?.startsWith("trial") ? trialEndsAt : currentTermEndsAt;
  const active =
    loaded &&
    subscriptionLoaded &&
    status != null &&
    ["live", "active", "trial", "trialing", "non_renewing"].includes(status) &&
    end != null &&
    Number.isFinite(new Date(end).getTime()) &&
    new Date(end).getTime() > now;

  return {
    active,
    allowed: isSponsoredRole(role) || active,
    pending: !loaded || (loading && !subscriptionLoaded),
  };
}
